import styled from "styled-components";

import {
  sectionTitle,
  actionListSubtitle,
  fontSizes,
  lineHeights,
} from "../../shared/styles/typography";

import { pageRoot } from "../../styles/pageRoot";

export const Container = styled.div`
  ${pageRoot}
  background: var(--color-background);
  padding: 2.4rem;
  align-items: center;
  gap: 2.4rem;

  @media (max-width: 768px) {
    padding: 1.6rem;
  }
`;

export const PageWrapper = styled.div`
  ${pageRoot}
  background: #f8fafc;
  align-items: center;
  padding-bottom: 100px;
`;

export const MobileCentralizer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  background: #fff;
  border-radius: 20px;
  padding: 4rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
`;

/** Card centralizado dentro do MobileLayout (completar cadastro / steps). */
export const MobileFormCard = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  background: var(--color-surface);
  border-radius: 20px;
  padding: 2.4rem 2rem 3.2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  border: 1px solid var(--color-border);
`;

export const StepsWrap = styled.div`
  margin-bottom: 2.4rem;

  .ant-steps-item-title {
    font-size: ${fontSizes.xs}px !important;
    line-height: ${lineHeights.xs}px !important;
    font-weight: var(--font-weight-semibold);
  }

  @media (max-width: 480px) {
    .ant-steps-item-title {
      font-size: ${fontSizes.xs}px !important;
    }
  }
`;

export const Title = styled.h1`
  font-size: ${fontSizes.xl}px;
  line-height: ${lineHeights.xl}px;
  color: var(--color-primary-dark);
  font-weight: var(--font-weight-bold);
  margin-bottom: 0.8rem;
`;

export const Subtitle = styled.p`
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-body);
  margin: 0;
`;

export const StepContainer = styled.div`
  margin-top: 2rem;
`;

export const StepActions = styled.div`
  margin-top: 3.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button:last-child {
    margin-left: auto;
  }

  button + button {
    margin-left: 1.6rem;
  }
`;

export const RadioGroup = styled.div`
  .ant-radio-group {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.2rem;
  }

  .ant-radio-button-wrapper {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px !important;
    border: 1.5px solid #e2e8f0 !important;
    font-weight: var(--font-weight-semibold);
    font-size: ${fontSizes.base}px;

    &::before {
      display: none !important;
    }

    &:hover {
      color: var(--color-primary);
    }

    &-checked {
      background: var(--color-primary) !important;
      color: #fff !important;
      border-color: var(--color-primary) !important;
    }
  }
`;

export const InfoBox = styled.div`
  background: #f8faff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;

  h3 {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-dark);
    margin-bottom: 1.6rem;
  }

  ul {
    padding-left: 2rem;
    li {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      color: var(--color-text-base);
      margin-bottom: 1rem;
    }
  }

  p {
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
    color: var(--color-text-base);
    margin-bottom: 1rem;
  }
`;

export const SectionHeader = styled.div`
  margin: 2.4rem 0 1.2rem;
  padding: 0 0.8rem;
`;

export const SectionTitle = styled.h3`
  ${sectionTitle}
  margin: 0;
`;

export const SectionHint = styled.p`
  ${actionListSubtitle}
  margin: 0.4rem 0 0;
`;

export const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1.2rem 4rem;

  @media (max-width: 768px) {
    padding: 0 0.8rem 2.4rem;
  }
`;

export const FormContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const AchievementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 1.6rem;
  margin-top: 1.6rem;
`;

export const AchievementCard = styled.div<{ $unlocked: boolean }>`
  background: ${(props) =>
    props.$unlocked
      ? "var(--color-surface)"
      : "var(--color-surface-secondary)"};
  border: 2px solid
    ${(props) =>
      props.$unlocked ? "var(--color-primary)" : "var(--color-border)"};
  border-radius: 16px;
  padding: 1.6rem;
  text-align: center;
  transition: all 0.3s ease;
  opacity: ${(props) => (props.$unlocked ? 1 : 0.6)};
  filter: ${(props) => (props.$unlocked ? "none" : "grayscale(1)")};

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .icon-wrapper {
    width: 64px;
    height: 64px;
    margin: 0 auto 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) =>
      props.$unlocked
        ? "var(--color-primary-lighter)"
        : "var(--color-surface-tertiary)"};
    border-radius: 12px;
    font-size: ${fontSizes["3xl"]}px;
  }

  h4 {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-title);
    margin-bottom: 0.4rem;
  }

  p {
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
    color: var(--color-text-complement);
    margin: 0;
  }
`;

export const LeagueInfoCard = styled.div`
  background: linear-gradient(135deg, #6366f1 0%, #4338ca 100%);
  border-radius: 20px;
  padding: 2.4rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 2.4rem;
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.2);

  .league-badge {
    width: 80px;
    height: 80px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${fontSizes["5xl"]}px;
    backdrop-filter: blur(4px);
  }

  .league-details {
    flex: 1;

    h4 {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      opacity: 0.9;
      margin-bottom: 0.4rem;
    }

    h3 {
      font-size: ${fontSizes.xl}px;
      line-height: ${lineHeights.xl}px;
      font-weight: var(--font-weight-bold);
      margin-bottom: 0.8rem;
    }

    .league-stats {
      display: flex;
      gap: 2rem;
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      font-weight: var(--font-weight-semibold);

      span {
        display: flex;
        align-items: center;
        gap: 0.6rem;
      }
    }
  }
`;

export const RankingTable = styled.div`
  background: var(--color-surface);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border);

  .ranking-header {
    padding: 2rem 2.4rem;
    border-bottom: 1px solid var(--color-border);
    h3 {
      margin: 0;
      font-size: ${fontSizes.base}px;
      line-height: ${lineHeights.base}px;
      font-weight: var(--font-weight-bold);
    }
  }

  .ranking-row {
    display: flex;
    align-items: center;
    padding: 1.6rem 2.4rem;
    gap: 1.6rem;
    transition: background 0.2s ease;

    &:hover {
      background: var(--color-surface-secondary);
    }

    &.me {
      background: color-mix(
        in srgb,
        var(--color-primary) 12%,
        var(--color-surface)
      );
      border-left: 4px solid var(--color-primary);
    }

    .position {
      width: 32px;
      font-weight: var(--font-weight-bold);
      font-size: ${fontSizes.base}px;
      color: var(--color-text-complement);

      &.top-1 {
        color: #f59e0b;
      }
      &.top-2 {
        color: #94a3b8;
      }
      &.top-3 {
        color: #b45309;
      }
    }

    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }

    .user-name {
      flex: 1;
      font-weight: var(--font-weight-semibold);
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
    }

    .user-xp {
      font-weight: var(--font-weight-bold);
      color: var(--color-primary);
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
    }
  }
`;

export const UserCard = styled.div`
  background: var(--color-surface);
  border-radius: 20px;
  padding: 3.2rem 2.4rem;
  margin-bottom: 2.4rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid var(--color-border);

  .avatar-wrapper {
    position: relative;
    margin-bottom: 1.6rem;

    .edit-btn {
      position: absolute;
      bottom: -4px;
      right: -4px;
      background: var(--color-primary);
      color: var(--color-title-in-primary);
      border: 3px solid var(--color-surface);
      width: 32px;
      height: 32px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    line-height: ${lineHeights.xl}px;
    font-weight: var(--font-weight-bold);
    color: var(--color-text-title);
    margin: 0;
  }

  .location {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
    color: var(--color-text-tertiary);
    margin-top: 0.8rem;
  }

  .email-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
    color: var(--color-text-secondary);
    margin-top: 0.4rem;
    word-break: break-all;
    padding: 0 0.8rem;
  }

  .tag-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.8rem;
    margin-top: 1.6rem;
  }
`;

export const Tag = styled.div`
  padding: 0.6rem 1.4rem;
  border-radius: 100px;
  font-size: ${fontSizes.sm}px;
  line-height: ${lineHeights.sm}px;
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: var(--color-primary-lighter);
  color: var(--color-primary);
  opacity: 0.9;
`;

export const FeatureCard = styled.div<{ $variant?: "primary" | "success" }>`
  background: ${(props) =>
    props.$variant === "success"
      ? "var(--color-success)"
      : "var(--color-primary)"};
  border-radius: 24px;
  padding: 2.4rem;
  margin-bottom: 1.6rem;
  color: #fff;
  position: relative;
  overflow: hidden;
  border: 2px solid
    ${(props) =>
      props.$variant === "success"
        ? "var(--color-success-dark)"
        : "var(--color-primary-dark)"};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2rem;
  }

  .badge {
    background: rgba(255, 255, 255, 0.25);
    padding: 0.6rem 1.2rem;
    border-radius: 12px;
    font-size: ${fontSizes.xs}px;
    line-height: ${lineHeights.xs}px;
    font-weight: var(--font-weight-bold);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .trophy-box {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .points-display {
    margin-bottom: 1.6rem;
    h4 {
      font-size: ${fontSizes.xl}px;
      line-height: ${lineHeights.xl}px;
      font-weight: var(--font-weight-bold);
      margin: 0;
    }
    p {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      opacity: 0.9;
      margin: 0.4rem 0 0;
    }
  }

  .stats-grid {
    display: flex;
    gap: 2.4rem;
    margin: 1.6rem 0;

    .stat-box {
      .val {
        font-size: ${fontSizes.xl}px;
        line-height: ${lineHeights.xl}px;
        font-weight: var(--font-weight-bold);
        display: block;
      }
      .lab {
        font-size: ${fontSizes.xs}px;
        line-height: ${lineHeights.xs}px;
        opacity: 0.8;
        font-weight: var(--font-weight-semibold);
      }
    }
  }

  .view-more-btn {
    width: 100%;
    margin-top: 1.2rem;
    padding: 1.2rem;
    border-radius: 14px;
    background: transparent;
    border: 2px solid rgba(255, 255, 255, 0.6);
    color: #fff;
    font-weight: var(--font-weight-semibold);
    font-size: ${fontSizes.sm}px;
    line-height: ${lineHeights.sm}px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .ant-progress-inner {
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .ant-progress-bg {
    background: #fff !important;
  }
`;

export const UsageCard = styled.div`
  background: var(--color-surface);
  border-radius: 20px;
  padding: 2.4rem;
  margin-bottom: 2.4rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--color-border);

  h4 {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-bold);
    margin: 0 0 1.6rem;
    color: var(--color-text-title);
  }

  .usage-list {
    display: flex;
    flex-direction: column;
  }
`;

export const UsageItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 0;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: none;
  }

  .item-left {
    display: flex;
    align-items: center;
    gap: 1.2rem;

    .icon-wrapper {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      font-weight: var(--font-weight-semibold);
      color: var(--color-text-title);
    }
  }

  .item-value {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: var(--font-weight-bold);
    color: var(--color-text-title);
  }
`;

export const GroupCard = styled.div`
  background: var(--color-surface);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 2.4rem;
  border: 1px solid var(--color-border);

  .group-header {
    padding: 2rem 2.4rem 0.8rem;
    h4 {
      font-size: ${fontSizes.base}px;
      line-height: ${lineHeights.base}px;
      font-weight: var(--font-weight-bold);
      color: var(--color-text-title);
      margin: 0;
    }
    p {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      color: var(--color-text-secondary);
      margin: 4px 0 0;
    }
  }
`;

export const ActionListItem = styled.button<{
  $danger?: boolean;
  $primary?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1.8rem 2.4rem;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: color-mix(
      in srgb,
      var(--color-primary) 12%,
      var(--color-surface)
    );
  }

  .icon-box {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => {
      if (props.$danger) return "rgba(239, 68, 68, 0.12)";
      if (props.$primary) return "var(--color-primary-lighter)";
      return "var(--color-surface-secondary)";
    }};
    color: ${(props) => {
      if (props.$danger) return "var(--color-danger)";
      if (props.$primary) return "var(--color-primary)";
      return "var(--color-text-secondary)";
    }};
  }

  .text-box {
    flex: 1;
    text-align: left;
    h5 {
      font-size: ${fontSizes.base}px;
      line-height: ${lineHeights.base}px;
      font-weight: var(--font-weight-semibold);
      color: ${(props) =>
        props.$danger ? "var(--color-danger)" : "var(--color-text-title)"};
      margin: 0;
    }
    span {
      font-size: ${fontSizes.sm}px;
      line-height: ${lineHeights.sm}px;
      color: var(--color-text-tertiary);
    }
  }

  .arrow-icon {
    color: var(--color-text-tertiary);
  }
`;
